import React, { useContext } from 'react';
import BannerSlider from './BannerSlider';
import Explore from './Explore';
import '../../assetss/scss/home.scss';
import Experties from './Experties';
import WorkProcess from './WorkProcess';
import ExpertiesHome from './ExpertiesHome';
import CompendiousMemorabilia from './CompendiousMemorabilia';
import PopularArticles from './PopularArticles';
import LatestArticles from './LatestArticles';
import PopularEvents from './PopularEvents';
import Testimonials from './Testimonials';
import InstitutionalMembers from './InstitutionalMembers';
import ImageModal from './ImageModal';
import { CommonContext } from '../../context';

const HomeScreenView = () => {
  const { indexData } = useContext(CommonContext);

  return (
    <div className={`module-main`}>
      {/* {isLoading && (
        <div className='text-center'>
          <Spinner color='primary' />
        </div>
      )} */}
      <ImageModal />
      <BannerSlider />
      <Explore />
      <Experties />
      {/* <WorkProcess /> */}
      <ExpertiesHome />
      {/* <PopularArticles /> */}
      {indexData?.events?.length > 0 && <PopularEvents />}
      <LatestArticles />
      <CompendiousMemorabilia />
      <Testimonials />
      <InstitutionalMembers />
    </div>
  );
}

export default HomeScreenView;
